module.exports = __webpack_public_path__ + "static/14-7a4400fa41156c6d216a84598fa36aa5.png";